<template>
  <table class="asd-table">
    <tr class="table-heading">
      <th>Vlastnost</th>
      <th>Stavovy graf</th>
    </tr>
    <tr v-for="pt in properties" :key="pt.key">
      <td>
        {{ pt.name }}
      </td>
      <td>
        <Multiselect
          v-model="value[pt.key]"
          label="label"
          trackBy="id"
          valueByPath="id"
          :returnAsSingle="true"
          :options="graphsSelect"
          :max="1"
        ></Multiselect>
      </td>
    </tr>
  </table>
</template>

<script>
import { map, get } from 'lodash'
import Multiselect from 'CORE/components/utilities/vue-multiselect-ext'

export default {
    name: 'AssignStatesTable',
    components: {
        Multiselect,
    },
    props: {
        properties: {
            type: Array,
            required: true,
        },
        value: {
            type: Object,
            required: true,
            default: _ => {return {}},
        },
    },
    data() {
        return {
            data: {},
        }
    },
    computed: {
        graphsSelect() {
            return map(get(this.$store.getters.settings, 'entity-states.graphs', []), (g, id) => {
                return { id, label: g.name }
            })
        },
    },
}
</script>

<style scoped>

</style>

